import React, { useEffect } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import {
    Box,
    Button,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Select,
    Flex,
} from "@chakra-ui/react";
import { fetchWrapper } from "../../helpers";
import { toast } from "react-toastify";

const UpdatePriceForm = ({ data, activeTab, id, currencyId, text, type }) => {
    const [loading, setLoading] = React.useState(false);
    const [initialValues, setInitialValues] = React.useState({});


    useEffect(() => {

        if (currencyId) {

            setInitialValues({ currency: currencyId })

        } else {
            setInitialValues({ currency: "" });
        }
    }, [currencyId])



    const validationSchema = Yup.object({
        currency: Yup.string().required("Currency is required"),
    });

    const handleSubmit = async (values) => {
        let payload = { currency_id: values.currency, channel_id: activeTab, id, type: type ? type : "" };
        try {
            setLoading(true);
            const url = `${process.env.REACT_APP_API_URL}/sale/update-currency-channel`;
            await fetchWrapper.post(url, payload);
            toast("Record has been saved", { type: "info" });
            setLoading(false);
        } catch (error) {
            toast("Record has not been saved", { type: "error" });
            setLoading(false);
        }
    };


    return (
        <Box mb={4} mt={4} style={{ width: "80%" }}>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ errors, touched, isSubmitting }) => (
                    <Form>
                        <Flex align="flex-end" gap={4}>
                            <Field name="currency">
                                {({ field }) => (
                                    <FormControl
                                        isInvalid={!!errors.currency && touched.currency}
                                        style={{ width: "15%" }}
                                    >
                                        <FormLabel>{text}</FormLabel>
                                        <Select {...field} placeholder="Select currency">
                                            {data?.map((currency) => (
                                                <option key={currency.id} value={currency.id}>
                                                    {currency.name}
                                                </option>
                                            ))}
                                        </Select>
                                        <FormErrorMessage>{errors.currency}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            <Button
                                colorScheme="blue"
                                type="submit"
                                isLoading={loading}
                            >
                                Update
                            </Button>
                        </Flex>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default UpdatePriceForm;
